<template>
    <v-card class="custom_card" @mouseover="mouseOver = true" @mouseleave="mouseOver = false">
        <div class="card_overlay_black" :class="[mouseOver ? 'active': '']">
            <v-layout row wrap>
                <v-flex xs4>
                    <div>
                        <v-icon x-large dark class="icon_left" @click="modeTestExperience(experienceTokens)"
                                @mouseover="iconPlay = true" @mouseleave="iconPlay = false">
                            fas fa-play
                        </v-icon>
                        <div class="text_icon" :class="[iconPlay ? 'active': '']">
                            tester
                        </div>
                    </div>
                </v-flex>
                <v-flex xs4>
                    <div>
                        <v-icon x-large dark class="icon_mid" @click="editExperience"
                                @mouseover="iconEdit = true" @mouseleave="iconEdit = false">
                            fas fa-pen
                        </v-icon>
                        <div class="text_icon" :class="[iconEdit ? 'active': '']">
                            éditer
                        </div>
                    </div>
                </v-flex>
                <v-flex xs4>
                    <div>
                        <v-icon x-large dark class="icon_right" @click="modeDeleteExperience(experienceTokens)"
                                @mouseover="iconDelete = true" @mouseleave="iconDelete = false">
                            fas fa-trash-alt
                        </v-icon>
                        <div class="text_icon" :class="[iconDelete ? 'active': '']">
                            supprimer
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <v-img v-if="experience.img" :src="'/image/' + experience.img" aspect-ratio="2.75" />
        <v-img v-if="!experience.img" src="/img/bg_default.jpg" aspect-ratio="2.75" />
        <v-card-title primary-title>
            <div class="experience_name">
                {{ experience.name }}
            </div>
        </v-card-title>
        <v-card-text>
            <p class="subtitle is-6">
                <span v-if="!experience.frozen" class="experience_active state_text">Activé</span>
                <span v-else class="experience_not_active state_text">Désactivé</span>
                <span class="state_text_date">Édité le {{ experienceDate }}</span>
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'ExperienceCard',
        props: {
            experience: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            mouseOver: false,
            iconPlay: false,
            iconEdit: false,
            iconDelete: false
        }),
        computed: {
            experienceDate: function () {
                let date = this.experience.update.split(' ')[0];
                let d = new Date(date);
                var today = new Date();
                let year = d.getFullYear() < today.getFullYear() ? d.getFullYear() : '';
                return d.toLocaleString('en-us', { month: 'short' }) + ' ' + d.getDate() + ' ' + year;
            },
            experienceTokens: function () {
                return {
                    experienceToken: this.experience.token,
                    organisationToken: this.experience.organisation
                };
            }
        },
        methods: {
            ...mapActions('experiences', ['modeTestExperience', 'modeDeleteExperience']),
            editExperience: function () {
                this.$router.push({
                    name: 'augmentations',
                    params: { experienceToken: this.experience.token }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>

    .v-card {
        min-height: 300px;
    }

    .experience_active {
        color: #169CEB;
    }

    .experience_not_active {
        color: #ff3860;
    }

    .v-card__title--primary {
        padding-top: 24px;
        padding-bottom: 5px;
    }

    .state_text {
        text-transform: uppercase;
        font-weight: bold !important;
        font-size: 15px;
    }

    .state_text_date {
        color: #8e939c;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: .3px;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-transform: uppercase;
        font-style: italic;
        margin-left: 10px;
    }

    .experience_name {
        color: #393E46;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.125;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .v-card__text {
        text-align: left;
    }

    .trash_checkbox {
        position: absolute;
        display: block;
        z-index: 2;
        width: 2vh;
        height: 2vh;
        left: 1vh;
        top: 1vh;
        transition: 0.3s ease;
        background-color: #FFF;
        border-radius: 5px !important;
        border: 3px white solid;
    }

    .trash_checkbox.checked {
        background-color: #ff3860 !important;
        transition: 0.3s ease;
    }

    .card_overlay {
        position: absolute;
        height: 100%;
        width: 100%;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: #ff3860;
        opacity: 0.3;
        border-radius: 5px;
        transition: opacity 0.3s ease;
    }

    .card_overlay.active {
        opacity: 0.5;
        transition: opacity 0.3s ease;
    }

    .card_overlay_black {
        position: absolute;
        height: 200px;
        width: 100%;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: rgba(21, 34, 53, .9);
        opacity: 0;
        border-radius: 5px;
        transition: all 0.3s ease;
    }

    .card_overlay_black.active {
        opacity: 1;
        transition: all 0.3s ease;
    }

    .card_overlay_black > div {
        height: 100%;
    }

    .card_overlay_black > div div {
        top: 50%;
        transform: translateY(-45%);
        position: relative;
    }

    .card_overlay_black .icon_mid {
        font-size: 40px;
        background-color: #169CEB;
        padding: 20px;
        border-radius: 50%;
        transition: all 0.3s ease;
    }

    .card_overlay_black .icon_mid:hover {
        background-color: #3273dc;
        transition: all 0.3s ease;
    }

    .card_overlay_black .icon_left,
    .card_overlay_black .icon_right {
        font-size: 25px !important;
        background-color: #4e535ab0;
        padding: 15px;
        border-radius: 50%;
        border: 2px #949494a3 solid;
        transition: all 0.3s ease;
    }

    .card_overlay_black .icon_left:hover,
    .card_overlay_black .icon_right:hover {
        background-color: #636971;
        transition: all 0.3s ease;
    }

    .card_overlay_black .icon_left:before {
        left: 2px;
        position: relative;
    }

    .card_overlay_black .text_icon {
        color: white;
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        font-weight: bold;
        margin-top: 15px;
        opacity: 0;
        transition: all 0.3s ease;
    }

    .card_overlay_black .text_icon.active {
        opacity: 1;
        transition: all 0.3s ease;
    }

    .custom_card {
        cursor: pointer;
        overflow: hidden;
        border-radius: 5px;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
    }

    .custom_card .v-responsive {
        min-height: 200px;
    }

    .v-responsive.v-image {
        border-radius: 5px 5px 0 0 !important;
    }
</style>
